export default {
  appliedTo: {
    PRODUCTS: 'Produits',
    ORDER: 'Commande',
    SHIPPING: 'Transport',
  },
}
